import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './localization/en';
import svTranslation from './localization/sv';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      sv: { translation: svTranslation }
    },
    lng: 'sv',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
